import { isFunction } from '../../core/utils';
import { getDerivedErrorConfig } from './utils';
export default function (instanceConfig) {
    function withError(requestFn) {
        function errorRequestFn(config) {
            var _a = (config || {}).errorConfig, globalErrorConfig = _a === void 0 ? {} : _a;
            var _b = getDerivedErrorConfig(globalErrorConfig, config), showError = _b.showError, _c = _b.errorRules, errorRules = _c === void 0 ? [] : _c, shouldShowError = _b.shouldShowError, _d = _b.ignoredErrorCodes, ignoredErrorCodes = _d === void 0 ? [] : _d;
            return requestFn(config)
                .catch(function (err) {
                var result = err.result;
                if (shouldShowError && ignoredErrorCodes.indexOf(result) === -1) {
                    var errorRule = errorRules.find(function (rule) {
                        if (Array.isArray(rule.match)) {
                            return rule.match.indexOf(result) > -1;
                        }
                        if (isFunction(rule.match)) {
                            return rule.match(err);
                        }
                        return rule.match === result;
                    });
                    var errorResult = void 0;
                    if (errorRule && isFunction(errorRule.handler)) {
                        errorResult = errorRule.handler(err);
                    }
                    else if (isFunction(showError)) {
                        errorResult = showError(err);
                    }
                    if (errorResult && errorResult.then) {
                        return errorResult.catch(function (rejected) {
                            if (rejected) {
                                return Promise.reject(rejected);
                            }
                            return Promise.reject(err);
                        }).then(function (resolved) {
                            if (resolved) {
                                return Promise.reject(resolved);
                            }
                            return Promise.reject(err);
                        });
                    }
                }
                return Promise.reject(err);
            });
        }
        return errorRequestFn;
    }
    ;
    return withError;
}
;
//# sourceMappingURL=index.js.map